import _regeneratorRuntime from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _toConsumableArray from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectSpread from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _defineProperty from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.set.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.string.sub.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.array.sort.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getPayMonthList as _getPayMonthList, payrollSubProjectList, sortSubProject, payrollSubProjectDelete, payrollSubProjectOnFile, getOnFileNotice,
// 归档提示
getCancelOnFileNotice,
// 取消提示
payrollSubProjectCancelOnFile,
// 取消归档
getAllSubProjectListGroupByPayMonth } from '@/api/payroll';
import { batchNotic } from 'api/payroll/pay-slip';
import ExportExcelDialog from '@/components/ExportExcelDialog';
import { mapState } from 'vuex';
export default {
  name: 'payrollWage',
  components: _defineProperty({}, ExportExcelDialog.name, ExportExcelDialog),
  data: function data() {
    return {
      search_name: '',
      payMonthList: [],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      activeName: '1',
      subProjectList: [],
      expandedKey: [],
      currentKey: '',
      checkedKey: [],
      groupMonth: [],
      dialogPay: false,
      // 合并工资表弹窗
      dialogActive: '1',
      // 合并工资表tab
      selectTable: {},
      // 合并工资表中选择项
      selectTable1: [],
      downloadPayLoad: false,
      timer: null,
      current: {
        children: [],
        key: '',
        label: ''
      },
      selectTableIds: [],
      tax_deduction_status_array: [],
      isCombine: false,
      dialogMerge: false,
      // 是否合并发送
      mergeCount: 0,
      // 合并发送人数
      cancleData: {}
    };
  },
  filters: {
    ThousandSeparator: function ThousandSeparator(input) {
      // 千位分隔符
      return input && input.toString().replace(/(^|\s)\d+/g, function (m) {
        return m.replace(/(?=(?!\b)(\d{3})+$)/g, ',');
      });
    }
  },
  computed: _objectSpread({
    size: function size() {
      return function (val) {
        if (val.length >= 12) {
          return 24;
        }
        if (val.length === 14) {
          return 20;
        }
        if (val.length > 14) {
          return 16;
        }
      };
    }
  }, mapState({
    // 货币
    currency: function currency(state) {
      return state.user.company_info.currency;
    }
  })),
  watch: {
    selectTable: {
      handler: function handler(v) {
        var _this = this;
        this.selectTable1 = [];
        var keys = Object.keys(v);
        keys.forEach(function (key) {
          var _this$selectTable;
          (_this$selectTable = _this.selectTable1).push.apply(_this$selectTable, _toConsumableArray(v[key]));
        });
      },
      immediate: true,
      deep: true
    }
  },
  created: function created() {
    var _this2 = this;
    this.$nextTick(function () {
      var pid = _this2.$route.query.pid;
      var name = _this2.$route.query.name;
      if (pid) {
        _this2.$set(_this2.cancleData, pid, 1);
        _this2.activeName = '3';
        _this2.$router.replace({
          query: {
            name: name
          }
        });
        _this2.handleClick();
      }
    });
  },
  mounted: function mounted() {
    this.init();
  },
  methods: {
    init: function init() {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this3.getPayMonthList();
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    handleAdd: function handleAdd() {
      // 新建子项目
      this.$router.push({
        path: '/payroll/wageModal',
        query: {
          name: this.$route.query.name
        }
      });
    },
    handleMerge: function handleMerge() {
      // 合并工资表
      this.dialogPay = true;
      this.handleDialogClick();
    },
    handleDialogClick: function handleDialogClick() {
      var _this4 = this;
      // 合并子项目 进行中 已归档
      getAllSubProjectListGroupByPayMonth({
        sub_project_status: this.dialogActive
      }).then(function (res) {
        if (res && res.code) {
          var groupMonth = [];
          // const keys = Object.keys(res.data || {})
          var keys = Object.keys(res.data);
          keys.forEach(function (item) {
            groupMonth.push({
              name: item,
              label: res.data[item]
            });
          });
          _this4.groupMonth = groupMonth;
        }
      });
    },
    handleSelectionChange: function handleSelectionChange(val, index) {
      // 获取表格选中项
      this.$set(this.selectTable, index, val);
    },
    selectable: function selectable(row) {
      var values = Object.values(this.selectTable)[0] || [];
      var tax_deduction_status = values.length >= 1 ? values[0].tax_deduction_status : '';
      return row.tax_deduction_status === tax_deduction_status || !tax_deduction_status;
    },
    // 合并工资表
    clickMerge: function clickMerge() {
      var _this5 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var keys, _yield$batchNotic, data;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              keys = Object.keys(_this5.selectTable);
              _this5.selectTableIds = [];
              _this5.tax_deduction_status_array = [];
              keys.forEach(function (item) {
                // 处理数据，拿到筛选项id
                if (_this5.selectTable[item].length) {
                  _this5.selectTable[item].forEach(function (tab) {
                    _this5.selectTableIds.push(tab.sub_project_id);
                    _this5.tax_deduction_status_array.push(tab.tax_deduction_status);
                  });
                }
              });
              _context2.next = 6;
              return batchNotic({
                sub_project_id: _this5.selectTableIds
              });
            case 6:
              _yield$batchNotic = _context2.sent;
              data = _yield$batchNotic.data;
              _this5.dialogMerge = data.is_show;
              _this5.mergeCount = data.is_count;
              if (!_this5.dialogMerge) _this5.confirmMerge();
            case 11:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    confirmMerge: function confirmMerge() {
      var _this6 = this;
      // 有数据请求接口
      if (this.selectTableIds.length) {
        if (Array.from(new Set(this.tax_deduction_status_array)).length !== 1) {
          this.$message.error(this.$t('i18n.0405dc7965aa420887a80d0e5ae99998'));
          return;
        }
        this.dialogPay = false;
        setTimeout(function () {
          var query = {
            relation_type: 4,
            relation_id: _this6.selectTableIds.join(','),
            sub_project_id: _this6.selectTableIds
          };
          if (_this6.isCombine) query.is_combine = _this6.isCombine ? '1' : '0';
          sessionStorage.setItem('payroll.wage.list.params', JSON.stringify(query));
          _this6.$router.push('/payroll/wage/list');
        }, 300);
      } else {
        this.$message({
          message: this.$t('payroll_salary_26'),
          type: 'warning'
        });
      }
    },
    getPayMonthList: function getPayMonthList() {
      var _this7 = this;
      // 获取子项目时间
      _getPayMonthList({
        search_name: this.search_name,
        sub_project_status: this.activeName
      }).then(function (res) {
        if (res && res.code === 1) {
          var payMonthList = [];
          if (!res.data.length) {
            _this7.payMonthList = [];
            _this7.subProjectList = [];
            return;
          }
          var node = {
            label: res.data && res.data[0].child ? res.data[0].child[0] : '',
            key: res.data && res.data[0].child ? res.data[0].child[0] : '',
            year: res.data && res.data[0].year ? res.data[0].year : '',
            children: []
          };
          res.data.forEach(function (item, index) {
            payMonthList.push({
              label: _this7.$t('payroll_wage_1', {
                key: item.year
              }),
              key: item.year,
              children: []
            });
            item.child.filter(function (cItem) {
              payMonthList[index].children.push({
                label: cItem,
                key: cItem,
                children: []
              });
              if (_this7.$route.query.name && cItem === _this7.$route.query.name) {
                node = {
                  label: cItem,
                  key: cItem,
                  year: item.year,
                  children: []
                };
              }
            });
          });
          _this7.handleNodeClick(node);
          _this7.payMonthList = payMonthList;
        }
      });
    },
    getPayrollSubProjectList: function getPayrollSubProjectList() {
      var _this8 = this;
      // 获取子项目列表
      this.subProjectList = [];
      payrollSubProjectList({
        pay_month: this.current.key,
        sub_project_status: this.activeName,
        search_name: this.search_name
      }).then(function (res) {
        _this8.subProjectList = res.data;
        if (Object.keys(_this8.cancleData).length) {
          // 取消归档数据3秒高亮
          var item = _this8.subProjectList.filter(function (item) {
            return _this8.cancleData[item.sub_project_id];
          });
          if (item.length) {
            var this_ = _this8;
            var timer = null;
            timer = setInterval(function () {
              this_.cancleData[item[0].sub_project_id] += 1;
              if (this_.cancleData[item[0].sub_project_id] === 4) {
                clearInterval(timer);
                delete this_.cancleData[item[0].sub_project_id];
              }
            }, 1000);
          }
        }
        if (_this8.subProjectList.length && _this8.$refs.sub) {
          _this8.$nextTick(function () {
            _this8.$refs.sub.scrollTop = 0;
          });
        }
      });
    },
    handleNodeClick: function handleNodeClick(val) {
      var _this9 = this;
      // 子项目时间点击
      if (val.children && !val.children.length) {
        this.expandedKey = [val.year];
        this.currentKey = val.key;
        this.checkedKey = [val.key];
        this.current = val;
        this.getPayrollSubProjectList();
        var query = JSON.parse(JSON.stringify({
          name: val.label,
          pid: this.$route.query.pid
        }));
        this.$router.push({
          query: query
        });
        this.$nextTick(function () {
          if (_this9.$refs.tree) {
            _this9.$refs.tree.setCurrentKey(_this9.currentKey);
            _this9.$refs.tree.setCheckedKeys(_this9.checkedKey);
          }
        });
      }
    },
    handleInput: function handleInput() {
      var _this10 = this;
      this.$router.push({
        query: {}
      });
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(function () {
        _this10.getPayMonthList();
      }, 1500);
    },
    handleClick: function handleClick() {
      // 进行中 已归档
      if (!Object.keys(this.cancleData).length) this.$router.push({
        query: {}
      });
      this.getPayMonthList();
    },
    handleCountSalary: function handleCountSalary(row, page) {
      var query = {
        name: this.$route.query.name
      };
      if (page) query.page = page;
      // 进行中 去算薪
      this.$router.push({
        path: '/payroll/wageSalary/' + row.sub_project_id,
        query: query
      });
    },
    handleEdit: function handleEdit(row) {
      // 进行中 编辑
      this.$router.push({
        path: '/payroll/wageModal/' + row.sub_project_id,
        query: {
          name: this.$route.query.name
        }
      });
    },
    handleArchive: function handleArchive(row) {
      var _this11 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var str, res;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              str = '<div>';
              _context3.next = 3;
              return getOnFileNotice({
                sub_project_id: row.sub_project_id
              });
            case 3:
              res = _context3.sent;
              if (res.data.is_show_notice) {
                str += "\n      <p>".concat(_this11.$t('payroll_wage_50'), "</p>\n      ");
              } else {
                str += "<p>".concat(_this11.$t('payroll_wage_49'), "</p>");
              }
              str += '</div>';
              // 进行中 归档
              _this11.$confirm(str, _this11.$t('229'), {
                confirmButtonText: _this11.$t('1031'),
                cancelButtonText: _this11.$t('66'),
                dangerouslyUseHTMLString: true,
                type: 'warning'
              }).then(function () {
                payrollSubProjectOnFile({
                  sub_project_id: row.sub_project_id
                }).then(function (res) {
                  _this11.$set(_this11.cancleData, row.sub_project_id, 1);
                  _this11.activeName = '3';
                  _this11.$router.push({
                    query: _objectSpread({}, _this11.$route.query)
                  });
                  _this11.handleClick();
                });
              });
            case 7:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    handleCancel: function handleCancel(row) {
      var _this12 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var str, res;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              // 取消归档
              str = '<div>';
              str += "<p>".concat(_this12.$t('payroll_wage_47'), "</p>");
              _context4.next = 4;
              return getCancelOnFileNotice({
                sub_project_id: row.sub_project_id
              });
            case 4:
              res = _context4.sent;
              if (res.data.is_show_notice) {
                str = "\n      <p>".concat(_this12.$t('payroll_wage_48'), "</p>\n      <p>").concat(_this12.$t('payroll_wage_51'), "</p>\n      ");
              }
              str += '</div>';
              _this12.$confirm(str, _this12.$t('229'), {
                confirmButtonText: _this12.$t('131'),
                cancelButtonText: _this12.$t('66'),
                dangerouslyUseHTMLString: true,
                type: 'warning'
              }).then(function () {
                payrollSubProjectCancelOnFile({
                  sub_project_id: row.sub_project_id
                }).then(function (res) {
                  _this12.$set(_this12.cancleData, row.sub_project_id, 1);
                  _this12.activeName = '1';
                  _this12.$router.push({
                    query: _objectSpread({}, _this12.$route.query)
                  });
                  _this12.handleClick();
                });
              });
            case 8:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    goToDetail: function goToDetail(state, item) {
      // 发放工资条
      this.$router.push({
        path: '/payroll/paywages-pay-slip/' + item.sub_project_id,
        query: {
          state: state,
          type: item.settlement_type,
          tax_deduction_status: item.tax_deduction_status
        }
      });
    },
    handleSome: function handleSome(command, item, index) {
      // 更多
      switch (command) {
        case 1:
          // 上移
          this.cliclUp(command, item, index);
          break;
        case 2:
          // 下移
          this.clickDown(command, item, index);
          break;
        case 3:
          // 删除
          this.handleDelete(item, index);
          break;
      }
    },
    handlerDragstart: function handlerDragstart(event, index) {
      event.dataTransfer.setData('Text', index);
    },
    handlerDrop: function handlerDrop(event, index) {
      event.preventDefault();
      // 获取被拖拽元素传递的索引
      var targetIndex = Number(event.dataTransfer.getData('Text'));
      var targetList = this.subProjectList;
      // 更换位置的数据
      var coverData = targetList.splice(targetIndex, 1)[0];
      targetList.splice(index, 0, coverData);
      targetList.forEach(function (item, index) {
        item.sort = index;
      });
      sortSubProject(targetList);
    },
    cliclUp: function cliclUp(command, row, index) {
      // 上移
      var targetList = this.subProjectList;
      var coverData = targetList.splice(index, 1)[0];
      targetList.splice(index - 1, 0, coverData);
      targetList.forEach(function (item, index) {
        item.sort = index;
      });
      sortSubProject(targetList);
    },
    clickDown: function clickDown(command, row, index) {
      // 下移
      var targetList = this.subProjectList;
      var coverData = targetList.splice(index, 1)[0];
      targetList.splice(index + 1, 0, coverData);
      targetList.forEach(function (item, index) {
        item.sort = index;
      });
      sortSubProject(targetList);
    },
    handleDelete: function handleDelete(row, index) {
      var _this13 = this;
      // 删除
      this.$confirm(this.$t('1032'), this.$t('229'), {
        confirmButtonText: this.$t('131'),
        cancelButtonText: this.$t('66'),
        type: 'warning'
      }).then(function () {
        var status = _this13.subProjectList.length === 1;
        payrollSubProjectDelete({
          sub_project_id: row.sub_project_id
        }).then(function (res) {
          if (res && res.code === 1) {
            _this13.$message({
              type: 'success',
              message: res.message
            });
            if (status) {
              _this13.$router.push({
                query: {}
              });
              _this13.getPayMonthList();
              return;
            }
            _this13.handleNodeClick(_this13.current);
          }
        });
      }).catch(function () {});
    }
  }
};